



















import Vue from "vue";

import ImageIcon from "@/components/atoms/ImageIcon.vue";
import CreateMemoIcon from "@/components/atoms/CreateMemoIcon.vue";

export default Vue.extend<{}, {}, Computed, {}>({
  components: { ImageIcon, CreateMemoIcon },
  computed: {
    canMemoPagePush() {
      return this.$route.meta.canMemoPagePush;
    },
  },
});

interface Computed {
  canMemoPagePush: boolean;
}
